import CRUDActions from '../CRUD';
import FafFeedTag from '../../api/fan_feed/fan_feed_tags';

class FafFeedTagCrud extends CRUDActions {
  prefix = 'fan_feed_tags';

  get _model() {
    return FafFeedTag;
  }

}

export default new FafFeedTagCrud();




// WEBPACK FOOTER //
// ./src/actions/fan_feed/fan_feed_tags.ts